import LocalStorageService from './general/local-storage-service';
import { StudySetsCookie } from 'study-types';

const UserStudyStorageService = {
  getStudyMaterialCookie(): StudySetsCookie | undefined {
    return LocalStorageService.get('study') as unknown as StudySetsCookie;
  },

  setStudyMaterialCookie(data: StudySetsCookie): void {
    LocalStorageService.set('study', data);
    return;
  },

  resetStudyMaterialCookie(): void {
    LocalStorageService.delete('study');
    return;
  },
};

export default UserStudyStorageService;
